import { render, staticRenderFns } from "./hicon.vue?vue&type=template&id=4a4c571e"
import script from "./hicon.vue?vue&type=script&lang=ts"
export * from "./hicon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports